// extracted by mini-css-extract-plugin
export default {"label":"Slider_label__v95dC","slider":"Slider_slider__VRpbC","span":"Slider_span__4CsE9"};